import React from 'react'
import { FormGroup, Label, Input, Alert, } from 'reactstrap'
import PropTypes from 'prop-types'

/**
 * Form for handling initial input of CSV. 
 */

function UploadInput ({handleUpload, uploadData, uploadError}) {
  return (
    <FormGroup>
      <Label htmlFor='upload'>Upload CSV (Other File Types Not Accepted)</Label>
      <Input
        type='file'
        accept='.csv'
        onChange={handleUpload}
      />
      {uploadData && <Alert className='mt-1'>Upload successful.</Alert>}
      {uploadError && <Alert>{uploadError}</Alert>}
    </FormGroup>
  )
}

const { array, func, string } = PropTypes
UploadInput.propTypes = {
  handleUpload: func.isRequired,
  uploadData: array,
  uploadError: string,
}

export default UploadInput


// WEBPACK FOOTER //
// ./src/components/Assessment/UploadCSVComponents/UploadInput.js